import React from 'react';
import { Bar, BarChart, CartesianGrid, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { axisTick, chart, tooltipStyle } from './chartTheme';

/** Bar histogram. Ported verbatim from D:\campaigning-system\src\components\charts\Histogram.tsx. */
const compact = (v) => (v >= 1000 ? `${(v / 1000).toFixed(1)}k` : `${v}`);

export function Histogram({ data, height = 220, color = chart.teal, highlightIndex }) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }} barCategoryGap="26%">
        <CartesianGrid stroke={chart.grid} vertical={false} />
        <XAxis dataKey="bucket" tick={axisTick} tickLine={false} axisLine={{ stroke: chart.axisLine }} dy={6} />
        <YAxis tick={axisTick} tickLine={false} axisLine={false} width={38} tickFormatter={compact} />
        <Tooltip {...tooltipStyle} cursor={{ fill: 'rgba(15,168,155,0.06)' }} formatter={(v) => compact(v)} />
        <Bar dataKey="count" radius={[4, 4, 0, 0]} maxBarSize={46}>
          {data.map((_, i) => (
            <Cell key={i} fill={highlightIndex === i ? chart.tealDeep : color} fillOpacity={highlightIndex === undefined || highlightIndex === i ? 1 : 0.72} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}

export default Histogram;
